<template>
  <v-container>
    <v-layout class="content-area-layout">
      <v-flex x12>
        <elevation-profile :points="points"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import loadingMixin from '@/mixins/loadingMixin';
import ElevationProfile from '@/ux/generic-components/ElevationProfile.vue';

export default {
  name: 'activity-elevation-view',
  components: {
    ElevationProfile,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  mixins: [loadingMixin],
  data: () => ({
    points: [],
  }),
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loadingStart('loading profile');
      this.points = await dataAccessor.getActivityStreams(this.id);
      this.loadingEnd();
    },
  },
};
</script>

<style>
</style>
